export default {
  name: 'utmOffer',
  component(props) {
    const { offer, variantId, productName } = props
    return {
      init() {},

      async activateOffer() {
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            // eslint-disable-next-line @typescript-eslint/naming-convention
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: offer.discountkit_title })
          })

          if (res.ok) {
            sessionStorage.setItem(
              'UTM_discount',
              JSON.stringify({
                discountKitTitle: offer.discountkit_title,
                utmKey: offer.utm_key,
                variantId,
                threshold: offer.threshold,
                productName
              })
            )
          }
          // @ts-expect-error - Dispatch event
          this.$dispatch('cart-updated')
        } catch (error) {
          console.error('[utmOffer]: Error activating offer', error)
        }
      }
    }
  }
}
